export interface MovieItem {
  id: string;
  title: string;
  titleEn: string;
  category: string;
  genres: string[];
  year: number;
  rating: number;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  isHot: boolean;
  isNew: boolean;
  isVip: boolean;
  updateInfo: string;
  episodeTotal: string;
  episodeCurrent: string;
  trailerUrl: string;
  relatedIds: string[];
}

export const categories = [
  { key: 'all', label: '全部' },
  { key: 'movie', label: '电影' },
  { key: 'tv', label: '电视剧' },
  { key: 'variety', label: '综艺' },
  { key: 'anime', label: '动漫' },
];

export const genresList = [
  '动作', '喜剧', '爱情', '科幻', '恐怖', '悬疑', '犯罪', '战争',
  '奇幻', '动画', '剧情', '历史', '武侠', '古装', '家庭', '冒险',
];

export const heroSlides = [
  {
    id: 'hero-1',
    movieId: 'm1',
    title: '星际穿越',
    titleEn: 'Interstellar',
    tagline: '跨越时空的爱与拯救',
    rating: 9.4,
    genres: ['科幻', '冒险', '剧情'],
    year: 2014,
    description: '一批探险者穿越虫洞，为人类寻找新家园的壮丽旅程。在浩瀚宇宙中，时间与空间的界限被打破，唯有爱能穿越一切维度。',
    bgImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20astronaut%20floating%20near%20massive%20black%20hole%2C%20dramatic%20cinematic%20lighting%20with%20warm%20golden%20accents%2C%20vast%20cosmic%20landscape%2C%20emotional%20and%20awe-inspiring%20composition%2C%20film%20grain%20texture%2C%20dark%20deep%20space%20background&width=1920&height=1080&seq=hero-1-cinema&orientation=landscape',
  },
  {
    id: 'hero-2',
    movieId: 'm7',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    tagline: '九十年代上海的繁华与变迁',
    rating: 8.7,
    genres: ['剧情', '爱情'],
    year: 2023,
    description: '九十年代的上海，人人争上游，阿宝也变成了宝总。成功过，失败过，在沪上弄潮儿女的传奇故事中，留下一段荡气回肠的繁华记忆。',
    bgImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20night%20with%20neon%20lights%2C%20elegant%20nostalgic%20atmosphere%2C%20warm%20golden%20street%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20film%20style%2C%20vintage%20aesthetic%2C%20dramatic%20lighting&width=1920&height=1080&seq=hero-2-cinema&orientation=landscape',
  },
  {
    id: 'hero-3',
    movieId: 'm4',
    title: '流浪地球2',
    titleEn: 'The Wandering Earth II',
    tagline: '人类命运共同体的壮丽史诗',
    rating: 8.3,
    genres: ['科幻', '冒险', '灾难'],
    year: 2023,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，年轻人再次挺身而出，展开争分夺秒的生死之战。',
    bgImage: 'https://readdy.ai/api/search-image?query=Massive%20space%20elevator%20and%20futuristic%20Earth%20engines%20on%20planet%20surface%2C%20epic%20sci-fi%20cinematic%20scene%20with%20dramatic%20clouds%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20film%20poster%20style%2C%20grand%20scale%20composition&width=1920&height=1080&seq=hero-3-cinema&orientation=landscape',
  },
];

export const movies: MovieItem[] = [
  {
    id: 'm1',
    title: '星际穿越',
    titleEn: 'Interstellar',
    category: 'movie',
    genres: ['科幻', '冒险', '剧情'],
    year: 2014,
    rating: 9.4,
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20astronaut%20floating%20near%20black%20hole%20in%20deep%20space%2C%20dramatic%20golden%20accent%20light%2C%20minimalist%20design%2C%20film%20poster%20style%2C%20dark%20cosmic%20background%2C%20clean%20composition&width=400&height=560&seq=poster-m1&orientation=portrait',
    description: '近未来的地球黄沙遍野，小麦、秋葵等基础农作物相继因枯萎病灭绝，人类不再像从前那样仰望星空，而是每日在沙尘暴的肆虐下倒数着所剩不多的光景。前NASA宇航员库珀接连在女儿墨菲的书房发现奇怪的重力场现象，随即得知在某个未知区域内前NASA成员仍在秘密进行一个拯救人类的计划。',
    director: '克里斯托弗·诺兰',
    actors: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦', '迈克尔·凯恩'],
    duration: '169分钟',
    region: '美国',
    isHot: true,
    isNew: false,
    isVip: false,
    updateInfo: '蓝光高清',
    episodeTotal: '1',
    episodeCurrent: '1',
    trailerUrl: '',
    relatedIds: ['m4', 'm6', 'm3'],
  },
  {
    id: 'm2',
    title: '肖申克的救赎',
    titleEn: 'The Shawshank Redemption',
    category: 'movie',
    genres: ['剧情', '犯罪'],
    year: 1994,
    rating: 9.7,
    poster: 'https://readdy.ai/api/search-image?query=Classic%20film%20poster%20of%20man%20standing%20in%20rain%20with%20arms%20outstretched%2C%20dramatic%20lighting%20from%20above%2C%20dark%20silhouette%20style%2C%20minimalist%20movie%20poster%20design%2C%20warm%20golden%20backlight%2C%20emotional%20freedom%20theme&width=400&height=560&seq=poster-m2&orientation=portrait',
    description: '一场谋杀案使银行家安迪蒙冤入狱，谋杀妻子及其情人的指控将囚禁他终生。在肖申克监狱的首次现身就让监狱"大哥"瑞德对他另眼相看。安迪在狱中结识了一帮好兄弟，也逐步成为肖申克监狱长沃登洗黑钱的重要工具。',
    director: '弗兰克·德拉邦特',
    actors: ['蒂姆·罗宾斯', '摩根·弗里曼', '鲍勃·冈顿'],
    duration: '142分钟',
    region: '美国',
    isHot: true,
    isNew: false,
    isVip: false,
    updateInfo: '4K修复版',
    episodeTotal: '1',
    episodeCurrent: '1',
    trailerUrl: '',
    relatedIds: ['m5', 'm8', 'm9'],
  },
  {
    id: 'm3',
    title: '盗梦空间',
    titleEn: 'Inception',
    category: 'movie',
    genres: ['科幻', '悬疑', '动作'],
    year: 2010,
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Surreal%20movie%20poster%20of%20city%20folding%20inward%20with%20silhouetted%20figures%2C%20mind-bending%20architecture%2C%20dark%20moody%20atmosphere%2C%20minimalist%20design%2C%20film%20poster%20style%2C%20warm%20amber%20highlights%20on%20dark%20background&width=400&height=560&seq=poster-m3&orientation=portrait',
    description: '道姆·柯布是一位经验老道的窃贼，在人们精神最为脆弱的睡梦中，他能潜入别人的梦境中盗取潜意识中的秘密。柯布这一罕见的技能使他成为企业间谍中最令人垂涎的对象，但也让他失去了所有他爱的一切。',
    director: '克里斯托弗·诺兰',
    actors: ['莱昂纳多·迪卡普里奥', '约瑟夫·戈登-莱维特', '艾利奥特·佩吉', '汤姆·哈迪'],
    duration: '148分钟',
    region: '美国',
    isHot: true,
    isNew: false,
    isVip: false,
    updateInfo: '蓝光高清',
    episodeTotal: '1',
    episodeCurrent: '1',
    trailerUrl: '',
    relatedIds: ['m1', 'm4', 'm6'],
  },
  {
    id: 'm4',
    title: '流浪地球2',
    titleEn: 'The Wandering Earth II',
    category: 'movie',
    genres: ['科幻', '冒险', '灾难'],
    year: 2023,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20massive%20planet%20engines%20on%20Earth%20surface%2C%20futuristic%20technology%2C%20dramatic%20orange%20and%20blue%20contrast%2C%20epic%20scale%2C%20minimalist%20film%20poster%20design%2C%20cinematic%20lighting&width=400&height=560&seq=poster-m4&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理', '王智'],
    duration: '173分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    isVip: false,
    updateInfo: '院线高清',
    episodeTotal: '1',
    episodeCurrent: '1',
    trailerUrl: '',
    relatedIds: ['m1', 'm3', 'm6'],
  },
  {
    id: 'm5',
    title: '绿皮书',
    titleEn: 'Green Book',
    category: 'movie',
    genres: ['剧情', '喜剧'],
    year: 2018,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Warm%20road%20trip%20movie%20poster%20with%20two%20men%20in%20vintage%20car%2C%201960s%20America%2C%20friendship%20theme%2C%20soft%20warm%20color%20palette%2C%20minimalist%20film%20poster%20design%2C%20nostalgic%20atmosphere&width=400&height=560&seq=poster-m5&orientation=portrait',
    description: '一名黑人钢琴家，为前往种族歧视严重的南方巡演，找了一个粗暴的白人混混做司机。在一路开车南下的过程里，截然不同的两人矛盾不断，引发了不少争吵和笑料。但又在彼此最需要的时候，一起共渡难关。',
    director: '彼得·法雷里',
    actors: ['维果·莫腾森', '马赫沙拉·阿里', '琳达·卡德里尼'],
    duration: '130分钟',
    region: '美国',
    isHot: false,
    isNew: false,
    isVip: false,
    updateInfo: '蓝光高清',
    episodeTotal: '1',
    episodeCurrent: '1',
    trailerUrl: '',
    relatedIds: ['m2', 'm8', 'm9'],
  },
  {
    id: 'm6',
    title: '阿凡达：水之道',
    titleEn: 'Avatar: The Way of Water',
    category: 'movie',
    genres: ['科幻', '冒险', '奇幻'],
    year: 2022,
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Underwater%20fantasy%20movie%20poster%20with%20blue%20alien%20figures%20swimming%20in%20bioluminescent%20ocean%2C%20ethereal%20lighting%2C%20magical%20aquatic%20world%2C%20minimalist%20film%20poster%20design%2C%20deep%20ocean%20background&width=400&height=560&seq=poster-m6&orientation=portrait',
    description: '故事发生在前作的十余年后，杰克·萨利已是潘多拉星球纳美族一方部族的族长。某天，有个部族的兄弟在海岸附近巡逻时遭到利器割喉身亡。通过现场勘查，杰克判断已经有人类的阿凡达混入了部落。',
    director: '詹姆斯·卡梅隆',
    actors: ['萨姆·沃辛顿', '佐伊·索尔达娜', '西格妮·韦弗', '凯特·温丝莱特'],
    duration: '193分钟',
    region: '美国',
    isHot: true,
    isNew: true,
    isVip: false,
    updateInfo: '院线高清',
    episodeTotal: '1',
    episodeCurrent: '1',
    trailerUrl: '',
    relatedIds: ['m1', 'm3', 'm4'],
  },
  {
    id: 'm7',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    category: 'tv',
    genres: ['剧情', '爱情'],
    year: 2023,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20nostalgic%20drama%20poster%20with%20elegant%20couple%20in%20vintage%20clothing%2C%20warm%20golden%20lighting%2C%20romantic%20atmosphere%2C%20Chinese%20TV%20drama%20poster%20style%2C%20soft%20focus%2C%20luxurious%20texture&width=400&height=560&seq=poster-m7&orientation=portrait',
    description: '九十年代的上海，人人争上游，阿宝也变成了宝总。成功过，失败过，在沪上弄潮儿女的传奇故事中，留下一段荡气回肠的繁华记忆。这是一部关于时代、关于人的史诗。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '45分钟/集',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    isVip: false,
    updateInfo: '更新至30集',
    episodeTotal: '30',
    episodeCurrent: '30',
    trailerUrl: '',
    relatedIds: ['m10', 'm11', 'm12'],
  },
  {
    id: 'm8',
    title: '当幸福来敲门',
    titleEn: 'The Pursuit of Happyness',
    category: 'movie',
    genres: ['剧情', '家庭'],
    year: 2006,
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Inspirational%20movie%20poster%20of%20father%20and%20son%20silhouette%20walking%20at%20sunset%2C%20warm%20golden%20hour%20light%2C%20emotional%20and%20hopeful%20mood%2C%20minimalist%20film%20poster%20style%2C%20urban%20cityscape%20background&width=400&height=560&seq=poster-m8&orientation=portrait',
    description: '克里斯·加德纳用尽全部积蓄买下了高科技治疗仪，却因价格高昂难以推销。妻子最终选择离开，他带着5岁的儿子相依为命。在最艰难的时刻，他凭借惊人的毅力获得了知名证券公司的实习机会，最终成为知名的金融投资家。',
    director: '加布里尔·穆奇诺',
    actors: ['威尔·史密斯', '贾登·史密斯', '桑迪·牛顿'],
    duration: '117分钟',
    region: '美国',
    isHot: false,
    isNew: false,
    isVip: false,
    updateInfo: '蓝光高清',
    episodeTotal: '1',
    episodeCurrent: '1',
    trailerUrl: '',
    relatedIds: ['m2', 'm5', 'm9'],
  },
  {
    id: 'm9',
    title: '触不可及',
    titleEn: 'Intouchables',
    category: 'movie',
    genres: ['剧情', '喜剧'],
    year: 2011,
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Heartwarming%20French%20comedy%20movie%20poster%20with%20two%20men%20laughing%20in%20wheelchair%20scene%2C%20warm%20joyful%20atmosphere%2C%20friendship%20bond%2C%20minimalist%20film%20poster%20design%2C%20soft%20natural%20lighting&width=400&height=560&seq=poster-m9&orientation=portrait',
    description: '因为一次跳伞事故，白人富翁菲利普瘫痪在床，欲招聘一名全职陪护。刚从监狱出来的黑人德希斯为了申领救济金前来应聘。虽然他对这份工作毫无兴趣，但菲利普还是一眼相中了这个与众不同的年轻人。',
    director: '奥利维耶·纳卡什 / 埃里克·托莱达诺',
    actors: ['弗朗索瓦·克鲁塞', '奥玛·赛', '安妮·勒尼'],
    duration: '112分钟',
    region: '法国',
    isHot: false,
    isNew: false,
    isVip: false,
    updateInfo: '蓝光高清',
    episodeTotal: '1',
    episodeCurrent: '1',
    trailerUrl: '',
    relatedIds: ['m2', 'm5', 'm8'],
  },
  {
    id: 'm10',
    title: '狂飙',
    titleEn: 'The Knockout',
    category: 'tv',
    genres: ['剧情', '犯罪'],
    year: 2023,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20intense%20police%20officer%20silhouette%20against%20dark%20city%20background%2C%20dramatic%20lighting%2C%20gritty%20atmosphere%2C%20Chinese%20TV%20series%20poster%20style%2C%20mysterious%20tone&width=400&height=560&seq=poster-m10&orientation=portrait',
    description: '一部扫黑除恶坚决斗争的回忆录，横跨二十年的群像叙事全景式展现时代变迁下的黑白较量与复杂人性。正义或许会迟到，但绝不会缺席。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    duration: '45分钟/集',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    isVip: false,
    updateInfo: '全39集',
    episodeTotal: '39',
    episodeCurrent: '39',
    trailerUrl: '',
    relatedIds: ['m7', 'm11', 'm12'],
  },
  {
    id: 'm11',
    title: '庆余年第二季',
    titleEn: 'Joy of Life 2',
    category: 'tv',
    genres: ['古装', '剧情', '武侠'],
    year: 2024,
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20warrior%20in%20flowing%20robes%2C%20ink%20wash%20painting%20style%2C%20dramatic%20composition%2C%20traditional%20Chinese%20aesthetic%2C%20warm%20earth%20tones%2C%20majestic%20atmosphere&width=400&height=560&seq=poster-m11&orientation=portrait',
    description: '范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣。范闲面临的是更加惊心动魄的朝堂斗争与生死考验。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    duration: '45分钟/集',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    isVip: false,
    updateInfo: '更新至24集',
    episodeTotal: '36',
    episodeCurrent: '24',
    trailerUrl: '',
    relatedIds: ['m7', 'm10', 'm12'],
  },
  {
    id: 'm12',
    title: '三体',
    titleEn: 'Three-Body',
    category: 'tv',
    genres: ['科幻', '剧情', '悬疑'],
    year: 2023,
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20mysterious%20cosmic%20signal%20and%20three%20suns%2C%20dark%20atmospheric%20design%2C%20minimalist%20style%2C%20deep%20space%20elements%2C%20intellectual%20and%20philosophical%20mood&width=400&height=560&seq=poster-m12&orientation=portrait',
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。纳米科学家汪淼被警官史强带到联合作战中心，潜入名为"科学边界"的组织，由此揭开了一个涉及外星文明的巨大阴谋。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    duration: '45分钟/集',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    isVip: false,
    updateInfo: '全30集',
    episodeTotal: '30',
    episodeCurrent: '30',
    trailerUrl: '',
    relatedIds: ['m7', 'm10', 'm11'],
  },
  {
    id: 'm13',
    title: '歌手2024',
    titleEn: 'Singer 2024',
    category: 'variety',
    genres: ['音乐', '真人秀'],
    year: 2024,
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20with%20singer%20performing%20on%20grand%20stage%2C%20dramatic%20spotlight%2C%20concert%20atmosphere%2C%20vibrant%20stage%20lighting%2C%20entertainment%20show%20poster%20style%2C%20musical%20energy&width=400&height=560&seq=poster-m13&orientation=portrait',
    description: '华语乐坛顶级歌手汇聚一堂，以现场直播的形式展开音乐竞演。每一位歌手都将用最真实的声音，为观众带来最震撼的音乐盛宴。全程直播，见证真实的力量。',
    director: '洪涛',
    actors: ['那英', '汪苏泷', '杨丞琳', '海来阿木', '二手玫瑰'],
    duration: '120分钟/期',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    isVip: false,
    updateInfo: '更新至8期',
    episodeTotal: '12',
    episodeCurrent: '8',
    trailerUrl: '',
    relatedIds: ['m16', 'm17', 'm18'],
  },
  {
    id: 'm14',
    title: '斗罗大陆2',
    titleEn: 'Soul Land 2',
    category: 'anime',
    genres: ['动画', '奇幻', '冒险'],
    year: 2024,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20fantasy%20martial%20arts%20hero%20in%20flowing%20robes%2C%20magical%20energy%20effects%2C%20epic%20fantasy%20world%2C%20vibrant%20animation%20style%2C%20dynamic%20composition%2C%20mystical%20atmosphere&width=400&height=560&seq=poster-m14&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。在这里，没有魔法和斗气，只有武魂。唐三能否在这片武魂的世界中，重塑唐门辉煌？',
    director: '沈乐平',
    actors: ['配音：张杰', '配音：乔诗语'],
    duration: '25分钟/集',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    isVip: false,
    updateInfo: '更新至156集',
    episodeTotal: '208',
    episodeCurrent: '156',
    trailerUrl: '',
    relatedIds: ['m15', 'm19', 'm20'],
  },
  {
    id: 'm15',
    title: '凡人修仙传',
    titleEn: 'A Mortal\'s Journey to Immortality',
    category: 'anime',
    genres: ['动画', '奇幻', '武侠'],
    year: 2024,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%20with%20immortal%20warrior%20flying%20on%20sword%20through%20clouds%2C%20traditional%20Chinese%20ink%20style%2C%20mystical%20mountains%2C%20ethereal%20atmosphere%2C%20elegant%20animation%20art&width=400&height=560&seq=poster-m15&orientation=portrait',
    description: '普通的山村穷小子韩立，偶然之下加入到江湖门派，虽然资质平庸，但依靠自身努力和合理算计修炼成仙。一个平凡少年的修仙之路，充满了挑战与机遇。',
    director: 'B.CMAY',
    actors: ['配音：宝木中阳', '配音：张杰'],
    duration: '25分钟/集',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    isVip: false,
    updateInfo: '更新至98集',
    episodeTotal: '120',
    episodeCurrent: '98',
    trailerUrl: '',
    relatedIds: ['m14', 'm19', 'm20'],
  },
  {
    id: 'm16',
    title: '奔跑吧第八季',
    titleEn: 'Keep Running S8',
    category: 'variety',
    genres: ['真人秀', '喜剧'],
    year: 2024,
    rating: 7.2,
    poster: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20sunny%20day%2C%20energetic%20vibe%2C%20colorful%20and%20fun%20atmosphere%2C%20entertainment%20show%20style&width=400&height=560&seq=poster-m16&orientation=portrait',
    description: '兄弟团再度集结，开启全新的奔跑之旅。在欢笑与挑战中，他们将为观众带来最纯粹的快乐。全新的游戏环节，全新的嘉宾阵容，不变的奔跑精神！',
    director: '姚译添',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
    duration: '100分钟/期',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    isVip: false,
    updateInfo: '更新至6期',
    episodeTotal: '12',
    episodeCurrent: '6',
    trailerUrl: '',
    relatedIds: ['m13', 'm17', 'm18'],
  },
  {
    id: 'm17',
    title: '密室大逃脱第五季',
    titleEn: 'Great Escape S5',
    category: 'variety',
    genres: ['真人秀', '悬疑'],
    year: 2024,
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20variety%20show%20poster%20with%20dark%20corridor%20and%20flashlights%2C%20suspenseful%20atmosphere%2C%20group%20of%20people%20looking%20scared%2C%20dramatic%20lighting%2C%20entertainment%20show%20style&width=400&height=560&seq=poster-m17&orientation=portrait',
    description: '明星玩家们再次被投入精心设计的密室之中，他们需要在限定时间内，通过团队合作和智慧找到逃出密室的线索。悬疑升级，剧情更加烧脑。',
    director: '宋梓漪',
    actors: ['杨幂', '黄明昊', '大张伟', '张国伟', '许凯'],
    duration: '90分钟/期',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    isVip: false,
    updateInfo: '更新至10期',
    episodeTotal: '12',
    episodeCurrent: '10',
    trailerUrl: '',
    relatedIds: ['m13', 'm16', 'm18'],
  },
  {
    id: 'm18',
    title: '乘风2024',
    titleEn: 'Ride the Wind 2024',
    category: 'variety',
    genres: ['音乐', '真人秀', '竞演'],
    year: 2024,
    rating: 7.5,
    poster: 'https://readdy.ai/api/search-image?query=Elegant%20women%20music%20competition%20show%20poster%20with%20performers%20on%20stage%2C%20glamorous%20stage%20lighting%2C%20confident%20female%20energy%2C%20sparkling%20atmosphere%2C%20entertainment%20show%20style&width=400&height=560&seq=poster-m18&orientation=portrait',
    description: '30+位姐姐再次集结，她们将打破年龄的界限，用舞台证明自己的无限可能。每一位姐姐都是一朵独一无二的花，她们将在这个舞台上绽放最美的光芒。',
    director: '任洋',
    actors: ['戚薇', '韩雪', '袁娅维', '尚雯婕', '刘忻'],
    duration: '120分钟/期',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    isVip: false,
    updateInfo: '更新至7期',
    episodeTotal: '12',
    episodeCurrent: '7',
    trailerUrl: '',
    relatedIds: ['m13', 'm16', 'm17'],
  },
  {
    id: 'm19',
    title: '完美世界',
    titleEn: 'Perfect World',
    category: 'anime',
    genres: ['动画', '奇幻', '冒险'],
    year: 2024,
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Chinese%20anime%20poster%20with%20young%20hero%20battling%20mythical%20creatures%2C%20magical%20energy%20bursts%2C%20ancient%20oriental%20fantasy%20world%2C%20dynamic%20action%20scene%2C%20vibrant%20animation%20style&width=400&height=560&seq=poster-m19&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰。大荒之中，少年石昊横空出世。从大荒走出，一步步登临巅峰，他终将找到属于自己的完美世界。热血与感动交织的东方玄幻史诗。',
    director: '赵侠',
    actors: ['配音：苏尚卿', '配音：张杰'],
    duration: '25分钟/集',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    isVip: false,
    updateInfo: '更新至132集',
    episodeTotal: '156',
    episodeCurrent: '132',
    trailerUrl: '',
    relatedIds: ['m14', 'm15', 'm20'],
  },
  {
    id: 'm20',
    title: '一人之下5',
    titleEn: 'The Outcast 5',
    category: 'anime',
    genres: ['动画', '动作', '奇幻'],
    year: 2023,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20action%20anime%20poster%20with%20modern%20martial%20arts%20fighters%2C%20urban%20fantasy%20setting%2C%20dynamic%20fight%20pose%2C%20dark%20and%20stylish%20composition%2C%20cool%20animation%20art%20style&width=400&height=560&seq=poster-m20&orientation=portrait',
    description: '随着对异人世界的深入了解，张楚岚逐渐揭开了甲申之乱背后隐藏的惊天秘密。一场围绕着"八奇技"的斗争愈演愈烈，各路异人势力纷纷登场，大战一触即发。',
    director: '危天行',
    actors: ['配音：宝木中阳', '配音：小连杀'],
    duration: '25分钟/集',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    isVip: false,
    updateInfo: '全12集',
    episodeTotal: '12',
    episodeCurrent: '12',
    trailerUrl: '',
    relatedIds: ['m14', 'm15', 'm19'],
  },
];

export const aboutInfo = {
  brandName: '春夜影院',
  slogan: '春夜观影，畅享高清视界',
  introduction: '春夜影院成立于2020年，是一家致力于为广大影迷提供免费高清在线观影服务的综合性影视平台。我们秉持"让每个人都能享受优质影视内容"的理念，汇聚海量电影、电视剧、综艺、动漫等优质内容，以蓝光画质和流畅播放体验，为每一位用户打造沉浸式的观影之旅。',
  story: '春夜影院的名字源自一个简单的想法——在静谧的春夜里，与最爱的人一起，看一部好电影。我们相信，好的影视作品能够跨越时间和空间，触动每一个人的心灵。正是这份信念，支撑着我们从一个小小的影视分享社区，成长为今天拥有数百万用户的综合性影视平台。',
  features: [
    { title: '海量片库', description: '涵盖电影、电视剧、综艺、动漫等多种类型，持续更新，满足不同用户的观影需求。', icon: 'ri-movie-line' },
    { title: '蓝光画质', description: '提供1080P甚至4K超清画质，搭配高品质音效，带来影院级观影体验。', icon: 'ri-4k-line' },
    { title: '流畅播放', description: '全球CDN加速，智能码率调节，确保不缓冲、不卡顿的流畅播放体验。', icon: 'ri-speed-line' },
    { title: '完全免费', description: '所有内容均免费提供，无需付费会员，无需注册登录，打开即看。', icon: 'ri-vip-crown-line' },
    { title: '多端适配', description: '完美适配电脑、平板、手机等多种设备，随时随地畅享观影乐趣。', icon: 'ri-smartphone-line' },
    { title: '智能推荐', description: '基于观影偏好和历史记录，智能推荐用户可能喜欢的影视内容。', icon: 'ri-lightbulb-line' },
  ],
  stats: [
    { number: '10万+', label: '影视资源' },
    { number: '500万+', label: '活跃用户' },
    { number: '99.9%', label: '播放成功率' },
    { number: '24h', label: '内容更新' },
  ],
  reviews: [
    { name: '影迷小王', text: '春夜影院真的是我每天必上的网站，资源太全了，画质也超好，关键是免费的！强烈推荐给所有影迷朋友。', rating: 5 },
    { name: '追剧达人', text: '追剧党福音！更新速度超快，而且播放完全不卡，蓝光画质看电视剧简直是一种享受。已经推荐给身边所有朋友了。', rating: 5 },
    { name: '电影爱好者', text: '作为一个重度电影爱好者，春夜影院的片库深度让我惊喜。很多冷门佳作都能找到，而且都是高清版本，太赞了！', rating: 5 },
    { name: '综艺控', text: '综艺更新速度全网最快，而且不用等广告不用充会员，这种良心网站现在真的不多了。画质和流畅度都无可挑剔。', rating: 4 },
  ],
  contact: {
    email: 'contact@chunyecinema.com',
    wechat: '春夜影院官方',
    weibo: '@春夜影院',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    phone: '400-888-0000',
  },
};

export function getMoviesByCategory(category: string): MovieItem[] {
  if (category === 'all') return movies;
  return movies.filter(m => m.category === category);
}

export function getHotMovies(): MovieItem[] {
  return movies.filter(m => m.isHot);
}

export function getNewMovies(): MovieItem[] {
  return movies.filter(m => m.isNew);
}

export function getMovieById(id: string): MovieItem | undefined {
  return movies.find(m => m.id === id);
}

export function getRelatedMovies(ids: string[]): MovieItem[] {
  return ids.map(id => movies.find(m => m.id === id)).filter(Boolean) as MovieItem[];
}